// src/firebase/avatar.js
import { designTokens } from '../theme/theme';

const AVATAR_COLORS = designTokens.avatarColors;

export const generateAvatar = (name) => {
  const idx = name.charCodeAt(0) % AVATAR_COLORS.length;
  return { color: AVATAR_COLORS[idx], initials: name.slice(0, 2).toUpperCase() };
};
